import { Box, Button, Grid2, Typography } from "@mui/material"
import { Goddess } from "../types/types"

interface IResult {
    result: Goddess
}

const Result = ({result}: IResult) => {
    return(
        <>
            <Box textAlign='left' height='100vh'>
                <Grid2 container spacing={5}>
                    <Grid2 size={{xs: 12, sm: 4}}>
                    <Box
                        component="img"
                        height='100%'
                        width='100%'
                        alt={result.name}
                        src={'/images/' + result.image}
                    />
                    </Grid2>
                    <Grid2 size={{xs: 12, sm: 4}}>
                        <Typography variant="h1">
                            {result.name}
                        </Typography>
                        <Typography variant="h3">
                            {result.description}
                        </Typography>
                        <br/>
                        <Button size="large" color="error" variant="contained" target="_blank" href={result.link}>
                            Explore a essência de {result.name}
                        </Button>
                    </Grid2>
                    <Grid2 size={12}>
                        <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems='flex-start' height='40vh'>
                            <Typography variant="h5">
                                Combo 6 Ebooks Descubra a Deusa em Você.
                            </Typography>
                            <Typography variant="body2" fontSize={18}>
                                Por que adquirir o combo? <br/>
                                🔹 Receba todos os 6 e-books de uma vez e tenha acesso completo às forças das deusas. <br/>
                                🔹 Explore diferentes aspectos da sua personalidade, descobrindo como cada arquétipo está ativo em sua vida. <br/>
                                🔹 Aprenda a harmonizar as energias que influenciam suas emoções, relações e caminhos. <br/>
                                🔹 Um guia completo para aprofundar-se no feminino sagrado e criar a vida que você deseja. <br/>
                                <br/>
                                Seja você uma mulher que busca maior conexão com sua essência, equilíbrio nos seus ciclos ou clareza para suas escolhas, este combo é a ferramenta que você precisa para viver com autenticidade e força. <br/>
                                <br/>
                                Invista no seu despertar e abrace a deusa que você é! <br/>
                            </Typography>
                            <br/>
                            <Button size="large" color="error" variant="contained" target="_blank" href={result.link}>
                                Ver o Combo completo
                            </Button>
                        </Box>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}

export default Result